import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { observer } from 'mobx-react-lite';
import { footer, FooterClass } from "../../styles/Users.styles";
import { footerData } from '../../constants/footerConstant';
import { STRINGS } from '../../constants/strings';
import ChatBot from "../../components/Footer/ChatBot";

const Footer = () => {
  return (
    <>
      <Row alignmentHorizontal="justify" spacingInset="none 600 none none" className={FooterClass}>
        {footerData.map((footerItem) => (
          <Link href={footerItem.link} onClick={footerItem.onclick} target='_blank' type="secondary" key={footerItem.name}>
            <Text>{footerItem.name}</Text>
          </Link>
        ))}
      </Row>
      <Text className={footer}>{STRINGS.YEAR}</Text>
      <ChatBot />
    </>
  );
};

export default observer(Footer);
